import { AnyAction } from "redux-saga";
import { ACTIONS, IApplication } from "./type";

const initialState: IApplication = {
    settings: {
        artists: []
    },
    dob: '',
    loader: false,
    token: "",
    vote: null
}

export default function applicationReducer(state = initialState, action: AnyAction) {
    switch (action.type) {
        case ACTIONS.GET_SETTINGS_SUCCESS:
            return {
                ...state,
                settings: action.payload
            }
        case ACTIONS.UPDATE_AGE_STATE:
            return {
                ...state,
                dob: action.payload
            }
        case ACTIONS.UPDATE_LOADER:
            return {
                ...state,
                loader: action.payload
            }
        case ACTIONS.SAVE_VOTE:
            return {
                ...state,
                vote: action.payload
            }
        default:
            return state;
    }
}